import { useQuery } from '@tanstack/react-query';
import { getNotificationsUnreadCount } from '../../../api/notifications.api';
import { queryKeys } from '../../../api/queryKeys';
import { retryNotificationsQuery } from '../notificationsCache';
import { useNotificationsViewer } from './useNotificationsViewer';

/**
 * The number on the bell.
 *
 * Fetched once and then left to the socket, like the chat and ticket badges:
 * both socket events and both mark routes carry the new count, and each of
 * them writes it straight into this cache. The long staleTime is the safety
 * net for a tab that slept through events - it refetches when looked at again.
 */
export const useNotificationsUnreadCount = () => {
  const { userId, enabled } = useNotificationsViewer();

  const query = useQuery({
    queryKey: queryKeys.notifications.unreadCount(userId),
    queryFn: async () => {
      const { data } = await getNotificationsUnreadCount();
      return data.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: retryNotificationsQuery,
  });

  /* Undefined until the first answer, rather than 0: the bell rings when the
     count goes up, and a 0 that was never true would ring on every load. */
  return query.data?.unread;
};
